import React from 'react';
import { Box, Chip, Typography, Paper } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

interface VariableHelperProps {
  onSelect: (variable: string) => void;
}

const COMMON_VARIABLES = [
  { label: 'Student Name', value: '{{studentName}}' },
  { label: 'Class', value: '{{class}}' },
  { label: 'Section', value: '{{section}}' },
  { label: 'Admission No', value: '{{admissionNo}}' },
  { label: 'Parent Name', value: '{{parentName}}' },
  { label: 'Amount', value: '{{amount}}' },
  { label: 'Due Date', value: '{{dueDate}}' },
  { label: 'School Name', value: '{{schoolName}}' },
  { label: 'Date', value: '{{date}}' },
];

const VariableHelper: React.FC<VariableHelperProps> = ({ onSelect }) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2, bgcolor: 'background.default' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <InfoIcon fontSize="small" color="info" sx={{ mr: 1 }} />
        <Typography variant="subtitle2" color="textSecondary">
          Available Variables (Click to insert)
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {COMMON_VARIABLES.map((v) => (
          <Chip
            key={v.value}
            label={v.label}
            onClick={() => onSelect(v.value)}
            clickable
            size="small"
            variant="outlined"
            color="primary"
            sx={{ 
              '&:hover': { bgcolor: 'primary.light', color: 'white' }
            }}
          />
        ))}
      </Box>
    </Paper>
  );
};

export default VariableHelper;
